import type { DiTypes } from "@iot-platform/core";

export const adminTypes = Object.seal({
    repositories: {
        AdminRepository: Symbol.for("AdminRepository"),
    },
} satisfies DiTypes);
